import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const TecknaElavtal = lazy(() => import("@/pages/elavtal/TecknaElavtal"));

export const Route = createFileRoute("/elavtal/teckna")({
  head: () => seoHead("/elavtal/teckna"),
  component: () => <TecknaElavtal />,
});
